import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('RecommendedVehicles')(
  css({
    py: 'l',
    mb: ['m', 'm', 'default'],
  }),
);

themeStyles.addBaseStyles('Card')(({ theme }) =>
  css({
    display: 'block',
    py: 'm',
    px: 5,
    mx: ['l', 'zero', 'zero'],
    border: `1px solid ${theme.colors.grey[3]}`,
    textDecoration: 'none',
  }),
);

themeStyles.addBaseStyles('VehicleImageLink')(({ theme }) =>
  css({
    '&:focus-visible': {
      outline: `solid 4px ${theme.colors.aodaFocused}`,
      outlineOffset: '-4px',
    },
  }),
);

themeStyles.addBaseStyles('Name')(({ theme }) =>
  css({
    mb: 'xs',
    fontFamily: 'bold',
    textDecoration: 'none',
    display: 'block',
    '&:focus-visible': {
      outline: `solid 4px ${theme.colors.aodaFocused}`,
      outlineOffset: '-4px',
    },
  }),
);

themeStyles.addBaseStyles('VehicleImage')(
  css({
    width: '100%',
    height: '80px',
    objectFit: 'contain',
  }),
);

themeStyles.addBaseStyles('RecommendedVehicleDetails')(
  css({
    display: 'flex',
    mt: 'xs',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
);

export default themeStyles;
